import React, { useCallback } from 'react';

import Modal from '../../../shared/modals/modal.component';

import { Currency } from '../types';


type DeleteCurrencyModalProps = {
  entityToRemove: Currency,
  hideModal: () => void,
  removeEntity: (entity: Currency, options: { rowIndex: number }) => void,
  rowIndex: number,
  isRemovingEntity: boolean,
  isVisible: boolean,
}

const DeleteCurrencyModal = ({
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isRemovingEntity,
  isVisible,
}: DeleteCurrencyModalProps) => {
  const removeCurrency = useCallback(() => {
    if (entityToRemove) {
      removeEntity(entityToRemove, { rowIndex });
    }
  }, [removeEntity, entityToRemove, rowIndex]);

  return (
    <Modal
      className="delete-currency-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Currency"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeCurrency}
      isBusy={isRemovingEntity}
      isVisible={isVisible}
    >
      {entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/>
            Currency Code: {entityToRemove.currencyCode} <br />
          </div>
        )
        : null
      }
    </Modal>
  );
};

export default DeleteCurrencyModal;
